export default "__VITE_ASSET__DQ7Ma_zk__"